import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@core/auth/auth.service';

export const authGuard: CanActivateFn = (_route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (auth.isAuthenticated()) return true;

  // Carry where they were going, so signing in resumes it instead of dropping
  // everyone on the dashboard. safeReturnPath (read back in the login
  // component) is what stops this becoming an open redirect.
  return router.createUrlTree(['/login'], { queryParams: { returnTo: state.url } });
};
